module.exports = __webpack_public_path__ + "static/media/morskie.35afafef.svg";